import { GET_BANK_BRANCH_CODE } from '@stores/lead/constants.js';
import { setBankBranchCodeRequest } from '@stores/lead/action.js';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getBankBranchService } from '@services/lead/lead.js';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';

export function* getBankBranchCode({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getBankBranchService, payload);
    yield put(loadingSuccess());
    yield put(setBankBranchCodeRequest(response));

    if (callback) callback(response?.data);
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export default function* leadSaga() {
  yield takeLatest(GET_BANK_BRANCH_CODE, getBankBranchCode);
}
